<template>
    <div class="layout-location-list">
        <!--s: Search 区域-->
        <div class="location-list-search">
            <div class="location-list-select">
                <div class="box">
                    <span class="label" style="padding-left: 26px">查找：</span>
                    <Input prefix="ios-search" v-model="locationListParams.name" placeholder="名称" style="width: 210px" />
                    <Button @click="onReset">重置</Button>
                    <Button type="primary" @click="onSearch">查询</Button>
                </div>
                <div class="box">
                    <Button type="primary" icon="ios-add" @click="onAddList" class="right" style="margin-right: 26px">新增</Button>
                </div>
            </div>
        </div>
        <!--e: Search 区域-->
        <!--s: Data 区域-->
        <div class="location-list">
            <div class="record-header">
                <div class="box"><Icon custom="info-icon"></Icon>定位信息被作业流程引用后，不可进行编辑、删除操作</div>
            </div>
            <div class="table">
                <Table ref="selection" stripe="stripe" :height="locationListHeight" :loading="locationLoading" :columns="locationListColumns" :data="locationListArray.content">
                    <template slot-scope="{ row,index }" slot="名称">
                        <div class="list-input">
                          {{ !row.nameVisible?row.name:'' }}
                          <Input ref="refInput" v-model="locationListArray.content[index].name" v-if="row.nameVisible" maxlength="20" show-word-limit placeholder="请输入名称"/>
                        </div>
                    </template>
                    <template slot-scope="{ row,index }" slot="坐标ID">
                        <div class="list-input">
                            {{ !row.nameVisible?row.location:'' }}
                            <Input ref="refInput" v-model="locationListArray.content[index].location" v-if="row.nameVisible" placeholder="请输入坐标ID"/>
                        </div>
                    </template>
                    <template slot="操作" slot-scope="{ row,index }">
                        <div class="btn" v-if="row.nameVisible">
                            <a href="javascript:" @click="onAddLocationCheck(index)"><Icon type="ios-checkmark-circle-outline" /></a>
                            <a href="javascript:" @click="onClearLocation(index)"><Icon type="ios-close-circle-outline" /></a>
                        </div>
                        <div class="btn" v-if="!row.nameVisible">

                            <a href="javascript:" @click="onLookFlow(row)" style="font-size: 12px;width:auto;height:auto" v-if="row.locationReference.length !== 0">查看引用流程</a>
                            <Dropdown :transfer="true" v-if="row.locationReference.length === 0">
                                <a href="javascript:">
                                    <Icon type="md-more" />
                                </a>
                                <DropdownMenu slot="list" class="system-menu">
                                    <DropdownItem>
                                        <a href="javascript:" @click="onDelLocation(index)">删除</a>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <a href="javascript:" @click="onEditLocation(index)">编辑</a>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <a href="javascript:" @click="onMoveModal(index)">转移</a>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="location-list-page" v-if="locationListArray.content && locationListArray.content.length !== 0">
                <Page :total="locationListArray.totalSize" :current="locationListArray.currentPage" show-total show-sizer size="small" :page-size="locationListParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
            </div>
        </div>
        <!--e: Data 区域-->
        <Modal
            v-model="locationModalVisible"
            title="转移至"
            footer-hide>
            <div class="location-flow-body">
                <div class="list-item" :key="'child1'+key" v-for="(locationList,key) in locationTypeList">
                    <div class="item-thead" :class="selectId === locationList.value?'select-active':''" :style="locationList.children.length === 0?'padding-left:24px':''">
                        <a href="javascript:">
                            <Icon  v-if="locationList.children.length!==0" :type="locationList.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow"  @click="locationList.visible = !locationList.visible"/>
                            <Icon :custom="locationList.visible && locationList.children.length!==0?'menu-open-folder':'menu-folder'"></Icon>
                            <p @click="onSelect(locationList.value)">{{ locationList.label }}</p>
                        </a>
                    </div>
                    <div class="item-body" v-if="locationList.visible">
                        <div class="item-child" :key="'child2'+key" v-for="(children,key) in locationList.children">
                            <div class="child-thead" :class="selectId === children.value?'select-active':''" :style="children.children.length === 0?'padding-left:45px':''">
                                <a href="javascript:" class="href">
                                    <Icon v-if="children.children.length !== 0"  @click="children.visible = !children.visible" :type="children.visible?'md-arrow-dropdown':'md-arrow-dropright'" class="icon icon-arrow" />
                                    <Icon :custom="children.visible && children.children.length !== 0?'menu-open-folder':'menu-folder'"></Icon>
                                    <p @click="onSelect(children.value)">{{ children.label }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="location-footer">
                <Button @click="locationModalVisible = false;selectId = ''">取 消</Button>
                <Button type="primary" :loading="locationModalLoading" @click="onMoveSubmit">确 定</Button>
            </div>
        </Modal>
        <Modal
            v-model="locationFlowVisible"
            title="引用流程"
            footer-hide>
            <div class="location-flow-body">
                <div class="location-list-select">
                    <div class="box">
                      <Input prefix="ios-search" v-model="locationFlowName" placeholder="流程名称" style="width: 348px" />
                      <Button @click="onLocationFlowResetting">重置</Button>
                      <Button type="primary" @click="onLocationFlowSearch">查询</Button>
                    </div>
                </div>
                <div class="location-list-body">
                    <ul>
                        <li :key="key" v-for="(item,key) in locationFlowSearchArray"><Icon type="md-document" size="20"/>{{ item.flowName }}<a href="javascript:" @click="onFlowConfig(item)">打开</a></li>
                    </ul>
                    <div class="no-data" v-if="locationFlowSearchArray.length === 0">未找到您要搜索的数据</div>
                </div>
            </div>
        </Modal>

    </div>
</template>
<script>
import List from './list'
export default List
</script>
<style lang="less">
@import "list";
</style>
